import { useContext } from 'react';
import type { IWealthContextValues } from './wealth-context';
import { wealthContext } from './wealth-context';

/**
 * Hook that returns the values of the WealthContext.
 * @return {IWealthContextValues}
 */
export function useWealthContext(): IWealthContextValues {
    const context = useContext(wealthContext);
    if (context == null) throw new Error('useWealthContext must be used within a <WealthProvider>');

    return context;
}
